import { Col, Container, Row } from "reactstrap";
import { UserCards, Users } from "../../../../constants";
import { UserLists } from "../../../../data/applications/Users";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import UserCard from "../../../../coreComponents/UserCard";

const UsersCardsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={UserCards} parent={Users} />
      <Container fluid>
        <Row>
          {UserLists.map((user) => (
            <Col sm="6" xxl="3" xl="4" className="box-col-4" key={user.id}>
              <UserCard user={user}/>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default UsersCardsContainer;